import { render, staticRenderFns } from "./addPpc.vue?vue&type=template&id=1e94bd4e&scoped=true"
import script from "./addPpc.vue?vue&type=script&lang=js"
export * from "./addPpc.vue?vue&type=script&lang=js"
import style0 from "./addPpc.vue?vue&type=style&index=0&id=1e94bd4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e94bd4e",
  null
  
)

export default component.exports